// extracted by mini-css-extract-plugin
module.exports = {"box":"SystemSecurity_box__pBsOH","bg":"SystemSecurity_bg__F-Wzf","con":"SystemSecurity_con__1UQCd","desc":"SystemSecurity_desc__C9EBI","img":"SystemSecurity_img__1KKGe"};